import "./threeimage.css"
import dot from "../../assets/dots.svg"
import checkMarkIcon from "../../assets/checkmark-icon.svg"
import cardOneimage from "../../assets/2324.jpg"
import cardTwoimage from "../../assets/61.jpg"
import cardThreeimage from "../../assets/123652.jpg"
const ThreeImageTextSection = () => {
  return (
    <section className="three-image-text-section">
      <div className="container">
        <div className="three-image-text-wrapper">
          {/* Header */}
          <div className="image-text-header">
            <div className="section-tag">
              <img src={dot} alt="section-dots" />
              <p>Executive Dashboard</p>
            </div>
            <h2>One Dashboard. All the Answers Executives Need</h2>
            <p>
              Get a complete, executive-ready view of your systems in one place
            </p>
          </div>

          <div className="image-text-container">
            {/* Row 1 */}
            <div className="row">
              <div className="col-12 col-sm-5 col-md-5 col-lg-5">
                <img src={cardOneimage} alt="autonomous-operations" className="text-container-img"/>
              </div>
              <div className="col-12 col-sm-7 col-md-7 col-lg-7">
                <div className="image-text-div">
                  <h3>Uptime & Reliability Metrics</h3>
                    <p className="image-text-para">
                    At-a-glance visibility into SLA/SLO compliance — so executives know reliability goals are met without the noise
                  </p>
                  <CheckmarkItem text="24/7 continuous monitoring with zero downtime" />
                  <CheckmarkItem text="Automated triage and prioritization of critical threats" />
                  <CheckmarkItem text="Proactive attack and vulnerability prediction" />
                </div>
              </div>

            </div>

            {/* Row 2 (reversed) */}
            <div className="row reverse">
              <div className="col-12 col-sm-7 col-md-7 col-lg-7">
                <div className="image-text-div">
                  <h3>Cost & FinOps Impact</h3>
                  <p className="image-text-para">
                    Track real-time savings and efficiency gains from autonomous remediation, giving leadership a clear view of ROI
                  </p>
                  <CheckmarkItem text="Real-time cost optimization insights" />
                  <CheckmarkItem text="Autonomous remediation reduces cloud spend" />
                  <CheckmarkItem text="Budget forecasts tied directly to reliability metrics" />
                </div>
              </div>
              <div className="col-12 col-sm-5 col-md-5 col-lg-5">
                <img src={cardTwoimage} alt="integrated-intelligence" className="text-container-img"/>
              </div>
            </div>

            {/* Row 3 */}
            <div className="row">
               <div className="col-12 col-sm-5 col-md-5 col-lg-5">
                <img src={cardThreeimage} alt="compliance-governance" className="text-container-img"/>
              </div>
             <div className="col-12 col-sm-7 col-md-7 col-lg-7">
                <div className="image-text-div">
                  <h3>Incident Trends & MTTR</h3>
                    <p className="image-text-para">
                    Spot recurring bottlenecks early and measure mean time to resolution (MTTR) to ensure continuous improvement
                  </p>
                  <CheckmarkItem text="Instant root-cause analysis across incidents" />
                  <CheckmarkItem text="Historical trend tracking for recurring issues" />
                  <CheckmarkItem text="Executive-level MTTR insights to guide resourcing" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Reusable Checkmark component
const CheckmarkItem = ({ text }) => (
  <div className="checkmark-div">
    <div className="checkmark-icon">
      <img src={checkMarkIcon} alt="checkmark" />
    </div>
    <div>
      <p className="checkmark-div-p">{text}</p>
    </div>
  </div>
);

export default ThreeImageTextSection;
